/**
 * asset_packs — member → pack index for the .vpak asset packs (settlement study
 * R6, 2026-09-02). Pure so the harness pins it; AssetModule rebuilds the index
 * whenever the `asset_pack` rows change.
 */

export interface AssetPackRow { name: string; uri: string; members: string }
export interface PackRef { name: string; uri: string }

/** Version string of a row set (order-independent) — cheap change detection. */
export function packRowsVersion(rows: Iterable<AssetPackRow>): string {
  return [...rows].map((r) => `${r.name}@${r.uri}`).sort().join('|');
}

/** member object key → its pack. Malformed member lists are skipped, never thrown. */
export function buildPackIndex(rows: Iterable<AssetPackRow>): Map<string, PackRef> {
  const idx = new Map<string, PackRef>();
  for (const r of rows) {
    let members: unknown;
    try { members = JSON.parse(r.members); } catch { continue; }
    if (!Array.isArray(members)) continue;
    for (const m of members) if (typeof m === 'string' && m.length > 0) idx.set(m, { name: r.name, uri: r.uri });
  }
  return idx;
}

let optOut: boolean | null = null;
/** True when packs are switched off for this session (localStorage `atlas:asset-packs` = 'off' or `?assetPacks=off`). */
export function assetPacksOptedOut(): boolean {
  if (optOut !== null) return optOut;
  try {
    optOut = (typeof localStorage !== 'undefined' && localStorage.getItem('atlas:asset-packs') === 'off')
      || (typeof location !== 'undefined' && /[?&]assetPacks=off\b/.test(location.search));
  } catch { optOut = false; }
  return optOut;
}
